import {RepeaterDisplayType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/RepeaterDisplayType';
import {IPropertyTypeConfig} from '@mintdata/mint-kit/api/properties/PropertyTypeConfig';
import {AStringEnumConverter} from '@mintdata/mint-kit/impl/properties/converters/AEnumConverter';
import {AEnumEditor} from '@mintdata/mint-kit/impl/properties/editors/AEnumEditor';
import * as React from 'react';

export const RepeaterDisplayTypeConfig:IPropertyTypeConfig<RepeaterDisplayType> = {
    converter: AStringEnumConverter,
    editor: AEnumEditor
};
